(function () {
  $(function () {
    document
      .querySelector(".navbar-toggler")
      .addEventListener("click", function () {
        const navbarCollapse = document.querySelector(".navbar-collapse");
        if (navbarCollapse.classList.contains("show")) {
          navbarCollapse.classList.remove("show");
        } else {
          navbarCollapse.classList.add("show");
        }
      });

    const menuLinks = document.querySelectorAll("#menu-menu a");
    menuLinks.forEach((link) => {
      link.addEventListener("click", () => {
        // Selecciona el div con las clases especificadas
        const collapsibleDiv = document.querySelector(
          ".collapse.navbar-collapse.text-center.show"
        );

        // Si el div se encuentra, quita la clase 'show'
        if (collapsibleDiv) {
          collapsibleDiv.classList.remove("show");
        }
      });
    });

    window.addEventListener("scroll", function () {
      // Define el punto donde quieres que comience a cambiar la opacidad
      const triggerPoint = 400; // Por ejemplo, cuando se haga scroll a 300px
      const logoBackground = document.querySelector(".partial-logo-background");

      // Detecta la cantidad de scroll
      if (window.scrollY > triggerPoint) {
        logoBackground.style.opacity = "0"; // Aplica opacidad 0
      } else {
        logoBackground.style.opacity = "1"; // Aplica opacidad 1
      }
    });

    var carousel_timeline = $("#carousel-timeline");
    carousel_timeline.owlCarousel({
      loop: false,
      margin: 20,
      nav: true,
      navText: [
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"/></svg>',
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"/></svg>',
      ],
      dots: false,
      stagePadding: 20,
      responsive: {
        0: {
          stagePadding: 50,
          items: 2,
          margin: 110,
        },
        600: {
          items: 3,
        },
        767: {
          items: 4,
        },
        992: {
          items: 6,
        },
      },
    });

    var carousel_news = $("#carousel-news");
    var itemsCount = carousel_news.find(".item").length; // Cuenta los elementos dentro del carrusel

    carousel_news.owlCarousel({
      loop: itemsCount > 1, // El loop solo se activará si hay más de 1 ítem
      nav: true,
      navText: [
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"/></svg>',
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"/></svg>',
      ],
      dots: false,
      items: 1,
    });
  });
}).call(this);
